import { BlockJustify } from '../BlockSettings';
import { ColorPickerColors } from '../ColorPicker';
import LinkData from '../LinkData';
import BlockComponentValue from './BlockComponentValue';

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const ButtonSizeMap: Record<ButtonSize, string> = {
  [ButtonSize.SMALL]: '30%',
  [ButtonSize.MEDIUM]: '60%',
  [ButtonSize.LARGE]: '90%',
};

export interface ButtonComponentSettings {
  size?: ButtonSize;
  color?: ColorPickerColors;
  colorText?: ColorPickerColors;
  justify?: BlockJustify;
  border?: ColorPickerColors;
}

class BlockComponentButton implements BlockComponentValue {
  settings: ButtonComponentSettings;
  link?: LinkData;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentButton {
  export function make(link: LinkData, settings: ButtonComponentSettings): BlockComponentButton {
    return {
      settings,
      link,
    };
  }

  export function getDefault(size = ButtonSize.MEDIUM, color = ColorPickerColors.BLUE, justify = BlockJustify.CENTER): BlockComponentButton {
    return {
      settings: {
        size,
        color,
        justify,
      },
      link: LinkData.getDefault(),
    };
  }
}

export default BlockComponentButton;
